module.exports = __webpack_public_path__ + "static/img/score-pc-3.f8d55853.png";